// extracted by mini-css-extract-plugin
export var header = "_ww-1";
export var maskBottom = "_ww-6";
export var maskMiddle = "_ww-7";
export var maskTop = "_ww-5";
export var root = "_ww-0";
export var scrollDownButton = "_ww-3";
export var scrollDownButtonHidden = "_ww-4";
export var viewport = "_ww-2";